import React from 'react';

import { StylesType } from '../PageBuilderContentParser';
import {
  hasHorizontalMargin,
  withHorizontalMarginOnly,
} from 'src/utils/pageBuilderMargin';

interface EditorTypes {
  styles: StylesType;
  text: string;
}

const Editor: React.FC<EditorTypes> = ({ styles, text }) => {
  return (
    <div
      className="page-builder-text"
      data-pb-type="Editor"
      data-pb-variant={
        text.trim().startsWith('<h1') && text.trim().endsWith('</h1>')
          ? 'title'
          : 'text'
      }
      data-pb-hmargin={hasHorizontalMargin(styles.margin) || undefined}
      style={withHorizontalMarginOnly(styles)}
      dangerouslySetInnerHTML={{ __html: text }}
    />
  );
};

export default Editor;
